import { useState, forwardRef, useImperativeHandle } from 'react';
import { Alert, Button } from 'react-bootstrap';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { useAuth } from '../auth/AuthProvider';
import { updateProfile } from '../../controllers/user';

const PerfilAsesorForm = forwardRef((props, ref) => {
  const [nombreEsposo, setNombreEsposo] = useState(props.perfil?.nombre1 || '');
  const [nombreEsposa, setNombreEsposa] = useState(props.perfil?.nombre2 || '');
  const [apellido, setApellido] = useState(props.perfil?.apellido || '');
  const [tipo, setTipo] = useState(props.perfil?.tipoAsesor || 'sacerdote');
  const [telefono1, setTelefono1] = useState(props.perfil?.telefono1 || '');
  const [telefono2, setTelefono2] = useState(props.perfil?.telefono2 || '');
  const [alert, setAlert] = useState();
  const { token } = useAuth();

  useImperativeHandle(ref, () => ({
    getPerfil() {
      return generatePerfil();
    }
  }));

  function handleChange(e) {
    const value = e.target.value;
    switch (e.target.name) {
      case 'nombreEsposo': setNombreEsposo(value); break;
      case 'nombreEsposa': setNombreEsposa(value); break;
      case 'apellido': setApellido(value); break;
      case 'telefono1': setTelefono1(value); break;
      case 'telefono2': setTelefono2(value); break;
    }
  }

  function handleTipoChange(e) {
    const val = e.target.value;
    console.log(val);
    setTipo(val);
  }

  function generatePerfil() {
    return {
      tipo: 'asesor',
      nombre1: nombreEsposo,
      nombre2: nombreEsposa,
      apellido,
      tipoAsesor: tipo,
      telefono1,
      telefono2
    };
  }

  async function submitUpdate() {
    let p = generatePerfil();
    console.log(p);
    try {
      let r = await updateProfile(token, props.userId, p);
      setAlert(<Alert variant='success' onClose={() => setAlert()} dismissible>La información se actualizó con éxito.</Alert>);
    }
    catch (e) {
      console.log(e);
      setAlert(<Alert variant='danger' onClose={() => setAlert()} dismissible>Ocurrió un error. Por favor intenta de nuevo más tarde.</Alert>);
    }
  }
  
  function renderSaveButton() {
    if (props.updateProfile) {
      return <Form.Group className="mb-3 submit-buttons-wrapper">
        <Button key='submit-btn-perfil' type='submit' variant='primary' onClick={submitUpdate}>Actualizar perfil</Button>
      </Form.Group>;
    }
  }

  let tituloNombre = 'Nombre';
  let tituloTel1 = 'Teléfono';
  if (tipo === 'diacono') {
    tituloNombre = 'Nombre del esposo';
    tituloTel1 = 'Teléfono Esposo';
  }

  return <Row>
    <Col>
      {alert}
      <Form.Group className="mb-3">
        <Form.Label>Tipo de asesor</Form.Label>
        <Form.Select onChange={handleTipoChange}>
          <option value='sacerdote'>Sacerdote</option>
          <option value='diacono'>Diácono</option>
          <option value='religiosa'>Religiosa</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>{tituloNombre}</Form.Label>
        <Form.Control type="text" placeholder={tituloNombre} name='nombreEsposo' value={nombreEsposo} onChange={handleChange} required />
      </Form.Group>
      {tipo === 'diacono' && <Form.Group className="mb-3">
        <Form.Label>Nombre de la esposa</Form.Label>
        <Form.Control type="text" placeholder="Nombre de la esposa" name='nombreEsposa' value={nombreEsposa} onChange={handleChange} />
      </Form.Group>}
      <Form.Group className="mb-3">
        <Form.Label>Apellido</Form.Label>
        <Form.Control type="text" placeholder="Apellido" name='apellido' value={apellido} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>{tituloTel1}</Form.Label>
        <Form.Control type="number" placeholder={tituloTel1} name='telefono1' value={telefono1} onChange={handleChange} pattern='\d{10}' title='Formato 1234567890' required />
      </Form.Group>
      {tipo === 'diacono' && <Form.Group className="mb-3">
        <Form.Label>Teléfono Esposa</Form.Label>
        <Form.Control type="number" placeholder="Teléfono Esposa" name='telefono2' value={telefono2} onChange={handleChange} pattern='\d{10}' title='Formato 1234567890' required />
      </Form.Group>}

      {renderSaveButton()}
    </Col>
  </Row>;
});

export default PerfilAsesorForm;